import styled from "styled-components";

export const ScheduledOrderCard = styled.div`
  display: flex;
  background: ${({ theme }) => theme.palette.background.paper};
  padding: 16px;
  border-radius: 8px;
  flex-direction: column;
  gap: 16px;
`;

export const ScheduledOrderCardClientName = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ScheduledOrderCardLocationContainer = styled.div`
  display: flex;
  gap: 8px;
`;

export const ScheduledOrderCardLocation = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ScheculedOrderCardTimeRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  gap: 8px;
`;

export const ScheculedOrderCardTime = styled.div`
  width: fit-content;
  background: #fbefeb;
  padding: 8px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ScheculedOrderCardItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
